import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import PricingCard from './components/PricingCard';
import FAQSection from './components/FAQSection';
import TrustBadges from './components/TrustBadges';

const PricingPlans = () => {
  const [billingCycle, setBillingCycle] = useState('microbusiness');
  const [currency, setCurrency] = useState('KZT');
  const [selectedPlan, setSelectedPlan] = useState(null);

  const pricingPlans = {
    microbusiness: [
      {
        id: 'standard',
        name: 'Standard',
        icon: 'Rocket',
        description: 'Для старта. Автоматизация FAQ и первичная квалификация лидов.',
        price: 350000,
        priceUSD: 785,
        priceWithCRM: 450000,
        priceWithCRMusd: 1009,
        monthlyFee: 0,
        monthlyFeeUSD: 0,
        monthlyFeeWithCRM: 9000,
        monthlyFeeWithCRMusd: 20,
        billingPeriod: 'на год',
        billingPeriodWithCRM: 'на год',
        ctaText: 'Заказать',
        ctaLink: 'https://wa.me/77476660065',
        hasTwoPrices: true,
        features: [
          { text: '1 мессенджер (WhatsApp или Telegram)', included: true },
          { text: 'Умный сбор заявок 24/7', included: true },
          { text: 'Квалификация и сегментация', included: true },
          { text: 'Отправка КП и файлов в чат', included: true },
          { text: 'Авто-проверка платежа', included: true },
          { text: 'Техническая поддержка', included: true }
        ]
      },
      {
        id: 'enterprise',
        name: 'Enterprise',
        icon: 'Building2',
        description: 'Полная автоматизация воронки. Сложные интеграции, API и кастомная логика.',
        price: 600000,
        priceUSD: 1345,
        priceWithCRM: 750000,
        priceWithCRMusd: 1682,
        monthlyFee: 0,
        monthlyFeeUSD: 0,
        monthlyFeeWithCRM: 0,
        monthlyFeeWithCRMusd: 0,
        billingPeriod: 'на три года',
        billingPeriodWithCRM: 'на три года',
        ctaText: 'Заказать',
        ctaLink: 'https://wa.me/77476660065',
        hasTwoPrices: true,
        features: [
          { text: 'Все мессенджеры (WA, TG, Inst)', included: true },
          { text: 'Интеграция с API, БД, 1С', included: true },
          { text: 'Прием платежей прямо в чате', included: true },
          { text: 'Кастомная бизнес-логика', included: true },
          { text: 'Воронка + Reels сценарии', included: true },
          { text: 'Смена тематики: 3 раза', included: true },
          { text: 'Обработка Голоса и Фото', included: true }
        ]
      }
    ],
    corporate: [
      {
        id: 'standard',
        name: 'Standard',
        icon: 'Rocket',
        description: 'Срок: 2 года',
        price: 660000,
        priceUSD: 1480,
        monthlyFee: 9000,
        monthlyFeeUSD: 20,
        billingPeriod: 'единоразово',
        ctaText: 'Заказать',
        ctaLink: 'https://wa.me/77476660065',
        features: [
          { text: 'Только WhatsApp', included: true },
          { text: 'Ведет клиентов и передает в CRM', included: true },
          { text: 'Сбор заявок 24/7', included: true },
          { text: 'Экспертные консультации (База знаний)', included: false },
          { text: 'Обработка голосовых сообщений', included: false },
          { text: 'Обработка фото', included: false }
        ]
      },
      {
        id: 'business',
        name: 'Business',
        icon: 'Zap',
        description: 'Срок: 4 года',
        price: 1500000,
        priceUSD: 3363,
        monthlyFee: 9000,
        monthlyFeeUSD: 20,
        billingPeriod: 'единоразово',
        ctaText: 'Заказать',
        ctaLink: 'https://wa.me/77476660065',
        gift: 'Запуск таргета от нашего специалиста',
        features: [
          { text: '2 мессенджера на выбор (WhatsApp, Telegram, Instagram)', included: true },
          { text: 'Ведет клиентов и передает в CRM', included: true },
          { text: 'Сбор заявок 24/7', included: true },
          { text: 'Экспертные консультации (Спец. знания)', included: true },
          { text: 'Прослушивание голосовых сообщений', included: true },
          { text: 'Анализ фото (документы, товары)', included: true },
          { text: 'Поддержка действующих клиентов', included: true },
          { text: 'Персонализация на основе истории', included: true },
          { text: 'Рассылка полезных материалов', included: true },
          { text: 'Тех. поддержка: 6 месяцев', included: true },
          { text: 'Без смены тематики', included: false }
        ]
      },
      {
        id: 'premium',
        name: 'Premium',
        icon: 'Crown',
        description: 'Навсегда',
        price: 3000000,
        priceUSD: 6726,
        monthlyFee: 9000,
        monthlyFeeUSD: 20,
        billingPeriod: 'единоразово',
        billingNote: '0 ₸ абонплата (18 мес), далее 9 000 ₸',
        ctaText: 'Заказать',
        ctaLink: 'https://wa.me/77476660065',
        gifts: [
          'Стратегический тренинг для маркетинга от Айсезим',
          'Запуск таргета'
        ],
        features: [
          { text: 'Всё, что есть в тарифе за 1.5 млн', included: true },
          { text: 'Все 3 мессенджера (WhatsApp, Telegram, Instagram)', included: true },
          { text: 'Смена тематики: 3 раза', included: true },
          { text: 'Тех. поддержка: 1 год', included: true },
          { text: 'Приоритетное обслуживание', included: true },
          { text: 'Реклама на странице блогера @aisezym.sagatovna', included: true },
          { text: 'Подкаст под ключ с руководителем бизнеса', included: true }
        ]
      }
    ]
  };

  const handlePlanSelection = (ctaLink) => {
    window.open(ctaLink, '_blank', 'noopener,noreferrer');
  };

  const currentPlans = pricingPlans?.[billingCycle]?.map(plan => ({
    ...plan,
    displayPrice: currency === 'KZT' ? plan?.price : plan?.priceUSD,
    displayPriceWithCRM: currency === 'KZT' ? (plan?.priceWithCRM || plan?.price) : (plan?.priceWithCRMusd || plan?.priceUSD),
    displayMonthlyFee: currency === 'KZT' ? plan?.monthlyFee : plan?.monthlyFeeUSD,
    displayMonthlyFeeWithCRM: currency === 'KZT' ? (plan?.monthlyFeeWithCRM || plan?.monthlyFee) : (plan?.monthlyFeeWithCRMusd || plan?.monthlyFeeUSD)
  }));

  return (
    <>
      <Helmet>
        <title>Тарифы и цены - Jetu AI Platform</title>
        <meta 
          name="description" 
          content="Выберите оптимальный тариф Jetu AI для вашего бизнеса. Гибкие планы от стартапов до корпораций с прозрачным ценообразованием и калькулятором ROI." 
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-20">
          <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-secondary to-primary">
            <div className="container mx-auto px-4">
              <div className="max-w-3xl mx-auto text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 rounded-full mb-6">
                  <Icon name="Sparkles" size={20} color="var(--color-accent)" />
                  <span className="text-sm font-medium text-white">
                    Прозрачное ценообразование
                  </span>
                </div>
                
                <h1 className="text-4xl lg:text-5xl font-headline font-bold text-white mb-6">
                  Выберите план, который растет вместе с вашим бизнесом
                </h1>
                
                <p className="text-lg text-white/80 mb-8">
                  Начните с бесплатного пробного периода
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-2">
                    <button
                      onClick={() => setBillingCycle('microbusiness')}
                      className={`px-6 py-2 rounded-lg font-medium transition-all duration-200 ${
                        billingCycle === 'microbusiness' ?'bg-white text-primary shadow-lg' :'text-white hover:bg-white/10'
                      }`}
                    >
                      Микробизнес
                    </button>
                    <button
                      onClick={() => setBillingCycle('corporate')}
                      className={`px-6 py-2 rounded-lg font-medium transition-all duration-200 ${
                        billingCycle === 'corporate' ?'bg-white text-primary shadow-lg' :'text-white hover:bg-white/10'
                      }`}
                    >
                      Корпоративный
                    </button>
                  </div>

                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-2">
                    <button
                      onClick={() => setCurrency('KZT')}
                      className={`px-6 py-2 rounded-lg font-medium transition-all duration-200 ${
                        currency === 'KZT' ?'bg-white text-primary shadow-lg' :'text-white hover:bg-white/10'
                      }`}
                    >
                      KZT (₸)
                    </button>
                    <button
                      onClick={() => setCurrency('USD')}
                      className={`px-6 py-2 rounded-lg font-medium transition-all duration-200 ${
                        currency === 'USD' ?'bg-white text-primary shadow-lg' :'text-white hover:bg-white/10'
                      }`}
                    >
                      USD ($)
                    </button>
                  </div>
                </div>

                {billingCycle === 'corporate' && (
                  <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 bg-success/20 rounded-full">
                    <Icon name="TrendingDown" size={18} color="var(--color-success)" />
                    <span className="text-sm font-medium text-white">
                      Специальное предложение для новых клиентов Получите 20% скидку при выборе максимального плана
                    </span>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="py-16 lg:py-24">
            <div className="container mx-auto px-4">
              <div className={`grid grid-cols-1 ${currentPlans?.length === 2 ? 'lg:grid-cols-2' : 'lg:grid-cols-3'} gap-8 mb-16 max-w-5xl mx-auto`}>
                {currentPlans?.map((plan, index) => (
                  <PricingCard
                    key={plan?.id}
                    plan={plan}
                    isPopular={
                      (billingCycle === 'microbusiness' && index === 0 && currentPlans?.length === 2) ||
                      (billingCycle === 'corporate' && plan?.id === 'business')
                    }
                    onSelectPlan={() => handlePlanSelection(plan?.ctaLink)}
                    currency={currency}
                  />
                ))}
              </div>

              <TrustBadges />
            </div>
          </section>

          <section className="py-16 lg:py-24 bg-muted/30">
            <div className="container mx-auto px-4">
              <FAQSection />
            </div>
          </section>

          <section className="py-16 lg:py-24">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto bg-gradient-to-br from-accent to-primary rounded-3xl p-12 text-center">
                <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Icon name="Rocket" size={40} color="#FFFFFF" />
                </div>
                
                <h2 className="text-3xl lg:text-4xl font-headline font-bold text-white mb-4">
                  Готовы начать автоматизацию?
                </h2>
                
                <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                  Присоединяйтесь к 10 000+ компаний, которые уже используют Jetu AI для автоматизации коммуникаций и роста бизнеса
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <Button
                    variant="default"
                    size="lg"
                    iconName="Play"
                    iconPosition="left"
                    onClick={() => window.location.href = '/demo-playground'}
                    className="bg-white text-primary hover:bg-white/90"
                  >
                    Попробовать демо
                  </Button>
                  <Button
                    variant="outline"
                    size="lg"
                    iconName="MessageSquare"
                    iconPosition="left"
                    onClick={() => window.location.href = '/contact-support'}
                    className="border-white text-white hover:bg-white/10"
                  >
                    Связаться с нами
                  </Button>
                </div>

                <div className="mt-8 flex items-center justify-center gap-8 text-white/80 text-sm">
                  <div className="flex items-center gap-2">
                    <Icon name="Check" size={16} />
                    <span>3 дня бесплатно</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Check" size={16} />
                    <span>Без привязки карты</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Check" size={16} />
                    <span>Отмена в любое время</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default PricingPlans;